export default __webpack_public_path__ + "9b1a69555338a903bc3d812179e25e2f.jpg";